import { render, staticRenderFns } from "./PendingExamsBar.vue?vue&type=template&id=a2655272&"
import script from "./PendingExamsBar.vue?vue&type=script&lang=ts&"
export * from "./PendingExamsBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports